import { IAppSearchBarConfig, SearchCriteriaSyncOptions } from 'src/app/shared/app-search-bar/app-search-bar.models';
import {
    animate,
    AnimationEvent,
    style,
    transition,
    trigger
} from "@angular/animations";
import {
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    ViewChild
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Select } from "@ngxs/store";
import { AutoUnsubscribe } from "ngx-auto-unsubscribe";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Observable, Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { RightPanelService } from "src/app/components/rightpanel/rightpanel.service";
import { NotificationService } from "src/app/services/notification/notification.service";
import { TenantService } from "src/app/services/tenant/tenant.service";
import { environment } from "src/environments/environment";

import { LazyLoadedWidgets } from "../../app-routing-lazy";
import { User } from "../../models/user";
import { LayoutService } from "../../services/layout.service";
import { UserService } from "../../services/user/user.service";
import { BaseComponent } from "../base.component";
import { MainConfigService } from "../layouts/main/main-config.service";
import { FeatureService } from "../preview-feature/preview-feature.service";
import { IMemberListItemContext } from "./../../pages/_searchs/member/member-search.model";
import { RoleService } from 'src/app/services/user/role.service';
import { UserViewsService } from 'src/app/services/user-views/user-views.service';
import { ActionService } from 'src/app/services/actions/action.service';
import { MemberService } from 'src/app/services/member/member.service';

@AutoUnsubscribe()
@Component({
    selector: "app-topbar",
    templateUrl: "./app.topbar.component.html",
    styleUrls: ["./app.topbar.component.scss"],
    animations: [
        trigger("topbarActionPanelAnimation", [
            transition(":enter", [
                style({ opacity: 0, transform: "scaleY(0.8)" }),
                animate(
                    ".12s cubic-bezier(0, 0, 0.2, 1)",
                    style({ opacity: 1, transform: "*" })
                ),
            ]),
            transition(":leave", [animate(".1s linear", style({ opacity: 0 }))]),
        ]),
    ],
})
export class AppTopbarComponent extends BaseComponent implements OnInit {

    notificationIcon: string = "fa-light fa-envelope";
    userViewIcon: string = "fa-light fa-circle-user";

    notifications: number = 0;

    errorMessage: string;
    userPhoto: any;
    clickInside: boolean;

    environmentData = environment;

    @ViewChild("searchDialog", { static: false })
    searchDialogElement: ElementRef;

    showResult: boolean;
    searchResultBlocked: boolean;

    cases: any[];

    eventFocus$$: Subscription;

    @Select(UserService.user)
    userInfo$: Observable<User>;

    memberSearchResult: IMemberListItemContext[];

    @Input("layout")
    public currentLayout: any;

    @ViewChild("searchInput") searchInputViewChild: ElementRef;


    searchBarConfig: IAppSearchBarConfig = {
        syncOption: SearchCriteriaSyncOptions.onFocus,
        searchResultsDisplayWindowHeight: "36vh",
        showErrorMessage: true
    };

    appVersion = environment.appVersion;
    userInfo$$: Subscription;
    viewsCount: any;

    ActionType: string = "UserView";

    constructor(
        public dialogService: DialogService,
        private rightPanelService: RightPanelService,
        public tenantService: TenantService,
        public roleService: RoleService,
        public layoutService: LayoutService,
        public confirmationService: ConfirmationService,
        public router: Router,
        public route: ActivatedRoute,
        public configService: MainConfigService,
        public userService: UserService,
        public featureService: FeatureService,
        private readonly notificationService: NotificationService,
        private readonly userViewsService: UserViewsService,
        private readonly actionService: ActionService,
        public readonly memberService: MemberService
    ) {
        super();
    }

    get currentRoleName() {
        return this.roleService.getState().currentRoleName;
    }

    async ngOnInit() {

        this.userInfo$$ = this.userInfo$
            .pipe(filter((_) => !!_))
            .subscribe((userInfo) => {
                const defaultValue = "assets/layout/images/avatar-male.jpg";
                const result = userInfo.photo;

                this.userPhoto = result || defaultValue;
            });

        this.notificationService.notification$
            .subscribe((notification) => {
                this.notifications = notification.filter(s => s.status == this.notificationService.markedUnRead).length;
            });


        this.userViewsService.userViewCount$
            .subscribe((count) => {
                this.viewsCount = count;
            });

        this.loadMessageContext();
    }

    async loadMessageContext() {
        await this.notificationService.getWorkAssignedItems({});
    }

    toggleRightPanelUserSettings() {
        this.toggleRightPanel(LazyLoadedWidgets.COMPONENT_RIGHTPANEL_SETTINGS);
    }

    toggleRightPanelPreviewFeatures() {
        this.toggleRightPanel(
            LazyLoadedWidgets.COMPONENT_RIGHTPANEL_PREVIEWFEATURES
        );
    }

    toggleRightPanel(panelId: string) {
        if (this.rightPanelService.customViewSync !== panelId) {
            this.rightPanelService.setCurrentCustomView(panelId);
        } else {
            this.rightPanelService.setCurrentCustomView(null);
        }
    }

    @HostListener("click")
    click() {
        this.clickInside = true;
    }

    @HostListener("document:click", ["$event"])
    processClick(event) {
        if (!this.clickInside) {
            this.showResult = false;
        }

        this.clickInside = false;
    }

    onSearchAnimationEnd(event: AnimationEvent) {
        switch (event.toState) {
            case "visible":
                this.searchInputViewChild.nativeElement.focus();
                break;
        }
    }

    async handleMyViewClick() {
        await this.router.navigate(['userviews'], { queryParams: {} });
    }

    async handleMessagesClick() {
        await this.router.navigate(['messages'], { queryParams: {} });
    }
}
